import { useTranslation } from "react-i18next"

import * as Scrivito from "scrivito"
import { ScrivitoLink } from "scrivito/scrivito-link/ScrivitoLink"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { SocialMedia } from "widgets/social-media/SocialMedia"

import { SocialsWidget } from "./SocialsWidgetClass"

Scrivito.provideComponent(SocialsWidget, ({ widget }) => {
  const { t } = useTranslation()
  return (
    <SocialMedia label={widget.get("title")}>
      <ScrivitoLink
        className="btn btn-tertiary btn--icon-only"
        to={widget.get("linkedin")}
        label={
          widget.get("linkedin")?.title() || t("Footer.SocialMedia.LinkedIn")
        }
      >
        <Icon name={IconName.LINKEDIN} />
      </ScrivitoLink>

      <ScrivitoLink
        className="btn btn-tertiary btn--icon-only"
        to={widget.get("xing")}
        label={widget.get("xing")?.title() || t("Footer.SocialMedia.Xing")}
      >
        <Icon name={IconName.XING} />
      </ScrivitoLink>

      <ScrivitoLink
        className="btn btn-tertiary btn--icon-only"
        to={widget.get("twitter")}
        label={
          widget.get("twitter")?.title() || t("Footer.SocialMedia.Twitter")
        }
      >
        <Icon name={IconName.TWITTER_X} />
      </ScrivitoLink>

      <ScrivitoLink
        className="btn btn-tertiary btn--icon-only"
        to={widget.get("youtube")}
        label={
          widget.get("youtube")?.title() || t("Footer.SocialMedia.Youtube")
        }
      >
        <Icon name={IconName.YOUTUBE} />
      </ScrivitoLink>

      <ScrivitoLink
        className="btn btn-tertiary btn--icon-only"
        to={widget.get("facebook")}
        label={
          widget.get("facebook")?.title() || t("Footer.SocialMedia.Facebook")
        }
      >
        <Icon name={IconName.FACEBOOK} />
      </ScrivitoLink>

      <ScrivitoLink
        className="btn btn-tertiary btn--icon-only"
        to={widget.get("instagram")}
        label={
          widget.get("instagram")?.title() || t("Footer.SocialMedia.Instagram")
        }
      >
        <Icon name={IconName.INSTAGRAM} />
      </ScrivitoLink>
    </SocialMedia>
  )
})
